import React from 'react';
import './Frenzy.css';
import './Colors.css';
import { Loop } from 'react-game-kit';
import FrenzyGame from './FrenzyGame';

const Frenzy:React.SFC = () => {
	return (
		<div className='Frenzy'>
			<div className='Frenzy-screen'>
				<Loop>
					<FrenzyGame />
				</Loop>
			</div>
		</div>
	);
}

export default Frenzy;
